import Parse from 'html-react-parser';

function BMP20155(props) {
    let svgCode =
    `<svg width="96" height="68" viewBox="0 0 96 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .radiation {
        ${props.radiation}
    }
    </style>
        <rect x="7.5" y="9.5" width="17" height="17" fill="${props.darkFill}" stroke="black" stroke-width="3"/>
        <rect class="radiation" x="7.5" y="43.5" width="17" height="17" fill="${props.highlightColour}" stroke="black" stroke-width="3"/>
    </svg>`

    props.svgReturn(41, svgCode, "bmp00155", 96, 68);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20155;